<template>
  <div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="cadastro_tipo">PF</label>
            <Editor class="editor_prime" style="background-color: white" editorStyle="height: 200px;" v-model="texto_documentos_pf" />

            <button @click="updateText('texto_pf', texto_documentos_pf)" class="btn btn-primary btn-sm">Salvar</button>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="cadastro_tipo">PJ</label>

            <Editor class="editor_prime" style="background-color: white" editorStyle="height: 200px;" v-model="texto_documentos_pj" />

            <button @click="updateText('texto_pj', texto_documentos_pj)" class="btn btn-primary btn-sm">Salvar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <cadastrar-doc-tipo-usuario />
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Documentos por tipo de usuário</h3>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th>Id</th>
                <th>Tipo</th>
                <th>Estado civil</th>
                <th>Tipo doc</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="doc_tipo_usuario in docs_tipo_usuario" :key="doc_tipo_usuario">
                <td data-label="Id">{{ doc_tipo_usuario.id }}</td>

                <td data-label="Nome">{{ doc_tipo_usuario.cadastro_tipo }}</td>

                <td data-label="Estado civil">{{ doc_tipo_usuario.estado_civil }}</td>

                <td data-label="Tipo doc">{{ doc_tipo_usuario.tipodoc }}</td>
                <td>
                  <a
                    id="navbarDropdown"
                    class="nav-link"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-pre
                  >
                    <i class="fa-solid fa-bars" style="color: gray"></i>
                  </a>

                  <div id="meu_menu" class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                    <div class="dropdown-divider"></div>

                    <a href="#" class="dropdown-item" @click="deletar(doc_tipo_usuario)">
                      <i class="fa-solid fa-trash"></i>
                      &nbsp;&nbsp; Deletar
                    </a>

                    <div class="dropdown-divider"></div>
                    <a href="#" data-toggle="modal" data-target="#detalhes-modal" @click="show(doc_tipo_usuario)" class="dropdown-item">
                      <i class="fa-solid fa-pen"></i>
                      &nbsp;&nbsp; Editar
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="detalhes-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      v-if="doc_tipo_usuario_selecionado"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Editar documento por tipo de usuário</h4>
              <br />

              <div class="form-group">
                <label for="cadastro_tipo">Tipo cadastro</label>
                <select class="form-control" id="cadastro_tipo" v-model="doc_tipo_usuario_selecionado.cadastro_tipo">
                  <option value="pf">PF</option>
                  <option value="pj">PJ</option>
                </select>
              </div>

              <div class="form-group">
                <label for="cadastro_tipo">Estado civil</label>
                <select class="custom-select rounded-0" id="estado_civil" v-model="doc_tipo_usuario_selecionado.estado_civil">
                  <option value="uniao_estavel">União estável</option>
                  <option value="casado">Casado</option>
                  <option value="divorciado">Divorciado</option>
                  <option value="separado judicialmente">Separado judicialmente</option>
                  <option value="viuvo">Viuvo</option>
                  <option value="solteiro">Solteiro</option>
                </select>
              </div>
              <div class="form-group">
                <label for="tipo_doc">Tipo documento</label>
                <input class="form-control" id="tipo_doc" type="text" v-model="doc_tipo_usuario_selecionado.tipodoc" />
              </div>

              <div class="form-group">
                <label for="obrigatorio">Obrigatório</label>
                <select class="form-control" id="obrigatorio" v-model="doc_tipo_usuario_selecionado.obrigatorio">
                  <option :value="0">Sim</option>
                  <option :value="1">Não</option>
                </select>
              </div>

              <button data-toggle="modal" data-target="#detalhes-modal" type="button" class="btn btn-primary btn-sm">Voltar</button>

              <button class="btn btn-success btn-sm" @click="update()">
                Salvar
                <i class="fa fa-save"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "primevue/editor";

export default {
  props: ["docs_tipo_usuario", "texto_pf", "texto_pj"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading, Editor },

  data() {
    return {
      isLoading: false,
      doc_tipo_usuario_selecionado: "",
      texto_documentos_pf: "",
      texto_documentos_pj: "",
    };
  },

  mounted() {
    console.log(this.docs_tipo_usuario);

    console.log(this.texto_pf);

    this.texto_documentos_pf = this.texto_pf.texto;
    this.texto_documentos_pj = this.texto_pj.texto;
  },

  methods: {
    show(doc_tipo_usuario) {
      this.doc_tipo_usuario_selecionado = doc_tipo_usuario;
    },

    deletar(doc_tipo_usuario) {
      this.doc_tipo_usuario_selecionado = doc_tipo_usuario;

      this.$swal
        .fire({
          title:
            "<h3 style='color:#616060'>Deseja deletar o tipo de documento por usuário<b><br/>" +
            this.doc_tipo_usuario_selecionado.tipodoc +
            "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.doc_tipo_usuario_selecionado.id,
            };

            axios
              .post(`/admin/documento_tipo_usuario/delete`, data)
              .then((response) => {
                this.showSuccessMessage("Documento deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.doc_tipo_usuario_selecionado.id,
        cadastro_tipo: this.doc_tipo_usuario_selecionado.cadastro_tipo,
        tipodoc: this.doc_tipo_usuario_selecionado.tipodoc,
        estado_civil: this.doc_tipo_usuario_selecionado.estado_civil,
        obrigatorio: this.doc_tipo_usuario_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    updateText(tipo, texto) {
      this.isLoading = true;

      let data = {
        tipo: tipo,
        texto: texto,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/texto_dinamico/update`, data)
        .then((response) => {
          this.showSuccessMessage("Texto atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
